module.exports = __webpack_public_path__ + "img/MATILDE_CRUZ.b0d85a94.jpeg";